<div class="control-panel ag-pa-md">
  @if ((searchHistrory === null || searchHistrory === undefined) && !loading) {
    <div class="hist-unavailable">
      <h6>Search History unavailable</h6>
    </div>
  }
  @if (loading) {
    <div style="margin-top: 50px; margin-left: 185px">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  }
  @if (searchHistrory && !loading) {
    <div>
      <div class="slide-notify" style="width: 400px">
        <h6 class="width-100" style="font-size: 1em">
          Your Search History ({{ currentSaveSearches }} of {{ maxSaveSearches }} saved)
          <i
            class="fa fa-times pull-right close-sidenav"
            aria-hidden="true"
            title="Close Text Block"
            (click)="closeNav()"
          ></i>
          <i aria-hidden="true" class="fa fa-trash" (click)="clear()" style="margin-left: 10px"></i>
        </h6>
        <hr style="border-color: var(--header-color); width: 100%" />
        @for (item of searchHistrory; track item; let i = $index) {
          <mat-card appearance="outlined" class="history-card ag-mb-sm">
            <mat-card-content>
              @for (data of item.displayInfo?.searchTerms; track data) {
                <div class="width-100">
                  <div class="width-100">
                    <span class="key">Search Term:</span>
                    <span class="value"> {{ data?.searchTerm }}</span>
                  </div>
                  <div class="width-100">
                    <span class="key">Search Index:</span>
                    <span class="value"> {{ data?.searchIndex }}</span>
                  </div>
                  <div class="width-100">
                    <span class="key">Resource:</span>
                    <span class="value"> {{ item.displayInfo?.resources.length }} Selected</span>
                  </div>
                </div>
              }
            </mat-card-content>
            <mat-card-actions align="end" fxLayoutGap="5px">
              <button
                mat-button
                type="button"
                aria-label="Search"
                class="ag-mat-button-primary"
                (click)="search(item.searchInfo)"
              >
                Search
              </button>
              @if ((sharedService.kidsCat$ | async) === false) {
                <button
                  mat-button
                  type="button"
                  aria-label="Modify"
                  class="ag-mat-button-primary"
                  (click)="modify(item.searchInfo)"
                >
                  Modify
                </button>
              }
              <button
                mat-button
                type="button"
                aria-label="More Details"
                class="ag-mat-button-primary"
                (click)="moreDetails(item.displayInfo)"
              >
                More Details
              </button>
            </mat-card-actions>
          </mat-card>
        }
      </div>
    </div>
  }
</div>
